import React from "react";
import ReactDOM from "react-dom/client";
import ReactGA from "react-ga4";
import { RouterProvider } from "react-router-dom";
import "./index.css";
import GraphQLProvider from "./providers/graphql-provider";
import reportWebVitals from "./reportWebVitals";
import router from "./router";

ReactGA.initialize("G-WY5DJMF4HT");
ReactGA.initialize("G-GNP073E3DC");

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <GraphQLProvider>
      <RouterProvider router={router} />
    </GraphQLProvider>
  </React.StrictMode>
);

reportWebVitals();
